import { render, staticRenderFns } from "./SaveLabellingButton.vue?vue&type=template&id=790ab770&"
import script from "./SaveLabellingButton.vue?vue&type=script&lang=js&"
export * from "./SaveLabellingButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports